/*
  Gallery -> variant sync
  ---------------------------------------------------------------------------
  Selecting a colour swatch already switched the gallery image. Going the other
  way did not: clicking a thumbnail (or moving the main slider with the arrows
  / a swipe) only swapped the picture, leaving the swatches, price, SKU and the
  add-to-cart form on the previously selected variant.

  This script closes that loop. When a customer lands on a piece of media that
  belongs to a variant, it ticks the matching option input(s) and fires a single
  `change` event, so the theme's own variant handler (slate.Variants) takes over
  and updates everything exactly as if the swatch had been clicked.

  Media that belongs to no variant - extra angles, or a colourway that isn't
  actually sold - is left alone on purpose: there is no variant to select.

  Deliberately standalone and defensive so it survives theme.js updates.
*/
(function () {
  if (window.__productVariantMediaSync) {
    return;
  }
  window.__productVariantMediaSync = true;

  var SECTION = '[data-section-type="product"]';
  var OPTION_INPUTS = 'select, input[type="radio"], input[type="checkbox"]';
  var syncing = false;

  function whenReady(callback) {
    var tries = 0;
    (function poll() {
      if (window.jQuery) {
        callback(window.jQuery);
        return;
      }
      if (tries++ > 200) {
        return;
      }
      setTimeout(poll, 50);
    })();
  }

  // "…/0RB3754__002_B1__P21__noshad__qt.jpg?v=1761211967&width=1200" -> filename
  function fileKey(url) {
    if (!url) {
      return null;
    }
    var path = String(url).split('?')[0].split('#')[0];
    var last = path.split('/').pop();
    return last ? last.toLowerCase() : null;
  }

  whenReady(function ($) {
    function productData($container) {
      var $json = $('#ProductJson-' + $container.attr('data-section-id'));
      if (!$json.length) {
        return null;
      }
      try {
        return JSON.parse($json.html());
      } catch (e) {
        return null;
      }
    }

    // Match on media id, image id and filename. Any one of the three is enough,
    // which keeps this working whether the markup carries media ids or image
    // ids, and even if featured_media is missing from the product JSON.
    function variantKeys(variant) {
      var keys = [];

      if (variant.featured_media) {
        if (variant.featured_media.id != null) {
          keys.push('id:' + variant.featured_media.id);
        }
        if (variant.featured_media.preview_image) {
          var previewFile = fileKey(variant.featured_media.preview_image.src);
          if (previewFile) {
            keys.push('file:' + previewFile);
          }
        }
      }

      if (variant.featured_image) {
        if (variant.featured_image.id != null) {
          keys.push('id:' + variant.featured_image.id);
        }
        var imageFile = fileKey(variant.featured_image.src);
        if (imageFile) {
          keys.push('file:' + imageFile);
        }
      }

      return keys;
    }

    function elementKeys($el) {
      var keys = [];

      var explicitVariant = $el.attr('data-variant-id');
      if (explicitVariant) {
        keys.push('variant:' + explicitVariant);
      }

      var imageId = $el.attr('data-image-id');
      if (imageId) {
        keys.push('id:' + imageId);
      }

      var href = $el.is('a') ? $el.attr('href') : $el.find('a').first().attr('href');
      var file = fileKey(href);
      if (file) {
        keys.push('file:' + file);
      }

      return keys;
    }

    function currentOptions($container) {
      var options = [];

      $container
        .find('[data-index^="option"]')
        .filter(OPTION_INPUTS)
        .each(function () {
          var $input = $(this);
          if ($input.is('select') || $input.prop('checked')) {
            options.push({
              index: $input.attr('data-index'),
              value: $input.val()
            });
          }
        });

      return options;
    }

    function findVariant($container, $el) {
      var product = productData($container);
      if (!product || !product.variants || !product.variants.length) {
        return null;
      }

      var keys = elementKeys($el);
      if (!keys.length) {
        return null;
      }

      var matches = $.grep(product.variants, function (variant) {
        if ($.inArray('variant:' + variant.id, keys) !== -1) {
          return true;
        }
        var variantKeyList = variantKeys(variant);
        for (var i = 0; i < variantKeyList.length; i++) {
          if ($.inArray(variantKeyList[i], keys) !== -1) {
            return true;
          }
        }
        return false;
      });

      if (!matches.length) {
        return null;
      }

      // One image can be shared by several variants (same colour, different
      // sizes). Prefer the one that keeps the customer's other choices intact,
      // and prefer an in-stock variant over a sold-out one.
      var chosen = matches[0];
      var bestScore = -1;
      var options = currentOptions($container);

      $.each(matches, function (i, candidate) {
        var score = candidate.available ? 0.5 : 0;

        $.each(options, function (j, option) {
          if (candidate[option.index] === option.value) {
            score += 1;
          }
        });

        if (score > bestScore) {
          bestScore = score;
          chosen = candidate;
        }
      });

      return chosen;
    }

    function selectedVariantId($container) {
      var value = $container
        .find('select[name="id"], input[name="id"]')
        .first()
        .val();
      return value ? String(value) : null;
    }

    function sync($el) {
      if (syncing || !$el || !$el.length) {
        return;
      }

      var $container = $el.closest(SECTION);
      if (!$container.length) {
        return;
      }

      var variant = findVariant($container, $el);
      if (!variant) {
        return;
      }

      if (String(variant.id) === selectedVariantId($container)) {
        return;
      }

      var changed = false;
      syncing = true;

      try {
        $.each(['option1', 'option2', 'option3'], function (index, key) {
          var value = variant[key];
          if (value === null || typeof value === 'undefined') {
            return;
          }

          var $inputs = $container
            .find('[data-index="option' + (index + 1) + '"]')
            .filter(OPTION_INPUTS);

          if (!$inputs.length) {
            return;
          }

          var $select = $inputs.filter('select');
          if ($select.length) {
            if ($select.val() !== value) {
              $select.val(value);
              changed = true;
            }
            return;
          }

          var $target = $inputs.filter(function () {
            return $(this).val() === value;
          });

          if ($target.length && !$target.prop('checked')) {
            $target.prop('checked', true);
            changed = true;
          }
        });
      } finally {
        syncing = false;
      }

      if (!changed) {
        return;
      }

      // One event is enough: the theme re-reads every option input, then
      // updates price, SKU, stock, the master select and the swatch label.
      $container
        .find('[data-index^="option"]')
        .filter(OPTION_INPUTS)
        .first()
        .trigger('change');
    }

    // Thumbnail clicks.
    $(document).on('click', '.product-single__thumbnail', function () {
      var $item = $(this).closest('[data-image-id]');
      sync($item.length ? $item : $(this));
    });

    // Main slider: arrows, swipe, and asNavFor moves.
    $(document).on('afterChange', '.my-gallery', function (event, slick, current) {
      if (!slick || !slick.$slides) {
        return;
      }
      sync($(slick.$slides.get(current)));
    });
  });
})();
